import type { FontId } from '@shared/schema/theme'

/**
 * ชุดฟอนต์ที่เลือกได้ในธีมของแต่ละ flow
 *
 * ตอนนี้ใช้ font stack ที่อาศัยฟอนต์ในเครื่อง + fallback ของระบบ (ไม่โหลดจากอินเทอร์เน็ต)
 * ถ้าต้องการให้ทุกเครื่องเห็นเหมือนกัน 100% ให้วางไฟล์ .woff2 ไว้ที่ public/fonts/
 * แล้วเพิ่ม @font-face ใน styles.css — ดูขั้นตอนใน README
 */

export const FONT_STACKS: Record<FontId, string> = {
  system:
    "system-ui, -apple-system, 'Segoe UI', 'Noto Sans Thai', 'Leelawadee UI', 'Sarabun', Roboto, sans-serif",
  sarabun: "'Sarabun', 'Noto Sans Thai', 'Leelawadee UI', system-ui, sans-serif",
  'noto-sans-thai': "'Noto Sans Thai', 'Sarabun', 'Leelawadee UI', system-ui, sans-serif",
  prompt: "'Prompt', 'Noto Sans Thai', 'Sarabun', 'Leelawadee UI', system-ui, sans-serif",
}

export const FONT_LABELS: Record<FontId, string> = {
  system: 'ฟอนต์ระบบ (แนะนำ)',
  sarabun: 'Sarabun',
  'noto-sans-thai': 'Noto Sans Thai',
  prompt: 'Prompt',
}
